import {
  makeRequired, stringValidator,
} from '../../../../../OUI/Inputs';

export const accountValidator = makeRequired(stringValidator);
